import { makeAutoObservable, runInAction } from "mobx";
import { onError } from "@/utils/onError";
// FR-003: pair editor store (UC702). Backs TariffPage.
export class SingleTariffStore {
    constructor(tariffService) {
        this.tariffService = tariffService;
        this.pair = null;
        this.isLoading = false;
        this.isSaving = false;
        makeAutoObservable(this);
    }
    setPair(pair) {
        this.pair = pair;
    }
    async init(advanceId) {
        if (!advanceId) {
            this.setPair(null);
            return;
        }
        this.isLoading = true;
        try {
            const pair = await this.tariffService.getPair(advanceId);
            runInAction(() => {
                this.pair = pair;
            });
        }
        catch (error) {
            onError(error, "Не удалось загрузить тариф");
        }
        finally {
            runInAction(() => {
                this.isLoading = false;
            });
        }
    }
    async savePair(pair) {
        this.isSaving = true;
        try {
            const result = await this.tariffService.upsertPair(pair);
            return result;
        }
        catch (error) {
            onError(error, "Не удалось сохранить тариф");
            return null;
        }
        finally {
            runInAction(() => {
                this.isSaving = false;
            });
        }
    }
    dispose() {
        this.pair = null;
        this.isLoading = false;
        this.isSaving = false;
    }
}
